import React, { Component } from 'react';
import DropdownTreeSelect, { DropdownTreeSelectProps, TreeNode } from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import isEqual from 'lodash/isEqual';
import '../styles/style.scss';

type MyProps = Omit<DropdownTreeSelectProps, 'onChange'> & {
  // using `interface` is also ok
  data: any;
  onChange: (currentNode: TreeNode, selectedNodes: TreeNode[]) => void;
  texts: any;
  onNodeToggle?: Function;
  className: any;
};

type MyState = {
  data: any;
  uncheckAll?: Function;
};
export default class Container extends Component<MyProps, MyState> {
  constructor(props: any) {
    super(props);
    this.state = { data: props.data };
  }
  componentWillReceiveProps = (nextProps: any) => {
    // @ts-ignore
    if (!isEqual(nextProps.data, this.state.data)) {
      this.setState({ data: nextProps.data });
    }
  };
  shouldComponentUpdate = (nextProps: any) => {
    return (
      !isEqual(nextProps.data, this.state.data) ||
      !isEqual(nextProps.texts, this.props.texts) ||
      nextProps.disabled !== this.props.disabled ||
      nextProps.className !== this.props.className
    );
  };
  findValue = (arr: any) => {
    for (let obj of arr) {
      obj.checked = false;
      if (obj.children) {
        let result: any = this.findValue(obj.children);
        if (result) {
          return arr;
        }
      }
      return arr;
    }
    return undefined;
  };

  render() {
    // @ts-ignore
    const { data, ...rest } = this.props;
    // @ts-ignore
    return (
      <>
        <DropdownTreeSelect data={this.state.data}  {...rest}  />
      </>
    );
  }
}
